import { render, staticRenderFns } from "./UserResetPass.vue?vue&type=template&id=01def1db&scoped=true&"
import script from "./UserResetPass.vue?vue&type=script&lang=js&"
export * from "./UserResetPass.vue?vue&type=script&lang=js&"
import style0 from "./UserResetPass.vue?vue&type=style&index=0&id=01def1db&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01def1db",
  null
  
)

export default component.exports